// import ProgressDetails from "./TrackingProgressComponent";
import TrackProgressInfo from "./TrackProgress";
import FooterComponent from "./FooterComponent";
import TrackingHeaders from "./HeaderComponent";
import OrderDetailsComponent from "./OrderDetailsComponent";
import { TabPanel, TabView } from "primereact/tabview";
import OrderDetailInfoComponent from "./OrderDetailInfoComponent";
import ImageComponent from "./ImagesComponents";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import DriverLocationComponent from "./DriverLocationDialog";
import VerifyAddressComponent from "./VerifyAddressDialog";
import { setTrackingNum, ShipmentTokenActionThunk, ShipmentTrackingActionThunk } from "../redux/slice/TrackingSlice";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../redux/AppStore";
export default function FormContentComponent() {
  const dispatch = useDispatch<AppDispatch>();
  const { trackingNumberFromURL } = useParams<{ trackingNumberFromURL: string }>(); 
    const location = useLocation();
 const token = new URLSearchParams(location.search).get("token");
  const [activeTab, setActiveTab] = useState(0);

   useEffect(() => {
    if (trackingNumberFromURL) {
      dispatch(setTrackingNum(trackingNumberFromURL));
      dispatch(
        ShipmentTrackingActionThunk({
          identity: trackingNumberFromURL,
          origin: "tracking",
          filtertype: "st"
        }),
      );    
    }
    if (token) {
      dispatch(
        ShipmentTokenActionThunk({
          token: token,
          origin: "tracking"
        }),
      );
    }
    <ImageComponent />
  }, [dispatch, trackingNumberFromURL, token]);

  return (
    <>
      <TrackingHeaders />
      <OrderDetailsComponent />
      <div className="container max-width_controll">
        <div className="row justify-content-center">
          <form className="msform">
           <ImageComponent />
            <div className="container">
              <fieldset>
                <div className="form-card">
                  <div className="row">
                    <div className="col_width">
                      <div className="tab_controller">
                        <div className="card tabpanel1" >
                          <TabView
                            activeIndex={activeTab}
                            onTabChange={(e: any) => {
                              setActiveTab(e.index);
                              if (e.index === 0) {
                                window.dispatchEvent(new Event("resize"));
                              }
                            }}
                            renderActiveOnly
                          >
                            <TabPanel header="Order Details" >
                              <OrderDetailInfoComponent />
                            </TabPanel>
                            <TabPanel header="Tracking Progress" className="custom-tab-dekstop">
                              <TrackProgressInfo />
                            </TabPanel>                           
                          </TabView>
                        </div>  
                      </div>
                    </div>                  
                  </div>
                </div>
              </fieldset>
            </div>
          </form>
        </div>
      </div>
      <FooterComponent /></>

  );

}
